import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, OutlinedInput, InputAdornment } from '@material-ui/core';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme, noPadding }) => ({
  height: noPadding ? 0 : 96,
  display: 'flex',
  justifyContent: 'space-between',
  ...(noPadding && {
    padding: 0
  }),
  ...(!noPadding && {
    padding: theme.spacing(0, 1, 0, 3)
  }),
  ...(noPadding && {
      height: 0
  }),
  ...(!noPadding && {
    height: 96
  }),
  '@media (min-width: 600px)': {
    height: noPadding ? 0 : 96,
    padding: noPadding ? 0 : theme.spacing(0, 1, 0, 3)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

TeamSearch.propTypes = {
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  noPadding: PropTypes.bool
};

export default function TeamSearch({ filterName, onFilterName, isTeam, isVendor, noPadding }) {

  return (
    <RootStyle noPadding={noPadding}>
      <SearchStyle
        value={filterName}
        onChange={onFilterName}
        placeholder={isTeam ? "Search Team member..." : isVendor ? "Search Vendor..." : "Search Client..."}
        startAdornment={
          <InputAdornment position="start">
            <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        }
      />
    </RootStyle>
  );
}
